export default "__VITE_ASSET__lA1nRGVL__"